
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speeds',
      description: 'Experience blazing-fast connection speeds without compromising security. Stream, download, and browse with unlimited bandwidth and zero throttling.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to servers in multiple countries around the world. Access geo-restricted content and enjoy a truly borderless internet experience.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Logs Policy',
      description: 'We never track, collect, or share your private data. Your online activities remain completely anonymous and private at all times.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Compatible with Windows, Mac, iOS, Android, and more for seamless protection everywhere.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is always available to help you with any questions or issues. Get assistance whenever you need it.'
    }
  ];

  return (
    <section id="features" className="py-24 px-6 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-star-line text-blue-600"></i>
            <span className="text-blue-600 text-sm font-semibold">Features</span>
          </div>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Our VPN?
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Discover the powerful features that make our VPN the perfect choice for your online security and privacy needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
